import { createAsyncThunk } from "@reduxjs/toolkit"
import { allPostsApi, allUsersApi } from "../../services/UserServices"

export const fetchUsers = createAsyncThunk('user/getAllUser', async () => {
  const response = await allUsersApi()
  return response.json()
})

export const fetchPosts = createAsyncThunk('user/getAllPosts', async () => {
  const response = await allPostsApi()
  return response.json()
})